import { API_SERVICES, type ApiService } from './api-services';
import { environment } from './environments/environment';
import type { IEnvironment } from './environments/i-environment';

/**
 * URL of one of the API's path mappings, host included.
 *
 * Every service sits behind one domain and is reached through its own mapping,
 * so this is the one place that knows how the two go together - and the only
 * place that has to change when a service moves to a new version. Callers name
 * the service they want and never build the base themselves.
 *
 * `api` is the default because it is the mapping at the version root: it
 * answers for every route no longer mapping claims, which is most of them.
 */
export function apiUrl(service: ApiService = 'api'): string {
  return toApiUrl(environment.api, service);
}

/**
 * The same resolution against a configuration the caller holds rather than the
 * one this library was built with - for the Angular module, which is handed its
 * environment by injection and should keep answering to that.
 */
export function toApiUrl(api: IEnvironment['api'], service: ApiService = 'api'): string {
  const version = api.versions?.[service] ?? api.version;

  // Joined rather than interpolated so an empty origin yields a root-relative
  // url, which is what a build served through a dev proxy needs, and so the
  // root mapping's empty path adds no trailing slash.
  const path = [version, API_SERVICES[service]].filter(Boolean).join('/');

  return `${api.origin.replace(/\/$/, '')}/${path}`;
}
